<template>
  <v-container color="grey lighten-4">
    <main-menu :menuOptions="menuOptions" ref="mainmenu"></main-menu>

    <div class="d-flex justify-center my-10">
      <v-card flat max-width="600">
        <v-card-title>
          <v-img
            src="@/assets/FrogiGo_full.png"
            max-height="50px"
            max-width="50px"
          ></v-img>
          {{ $t("label.reset_password") }}
        </v-card-title>
        <v-stepper v-model="forget_form">
          <v-stepper-header>
            <v-stepper-step :complete="forget_form > 1" step="1">
              {{ $t("label.mobile_no") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="forget_form > 2" step="2">
              {{ $t("label.validate_short_code") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="forget_form > 3" step="3">
              {{ $t("label.reset_password") }}
            </v-stepper-step>

            <v-divider></v-divider>
            <v-stepper-step :complete="forget_form > 4" step="4">
              {{ $t("label.complete") }}
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-12" flat>
                <v-row v-show="false">
                  <v-col>
                    <v-radio-group v-model="Member.RegisterType" row>
                      <v-radio
                        :label="$t('label.email')"
                        value="EMAIL"
                      ></v-radio>
                      <v-radio :label="$t('label.sms')" value="SMS"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row v-show="Member.RegisterType == 'EMAIL'">
                  <v-col>
                    <v-text-field
                      :label="$t('label.email')"
                      :rules="emailRules"
                      v-model="Member.Email"
                      type="email"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-show="Member.RegisterType == 'SMS'">
                  <v-col>
                    <select-country
                      v-model="Country"
                      :change="afterCountry"
                      item-text="CntyName"
                      item-value="CntyCode"
                      :label="$t('label.country')"
                      hide-no-data
                      :onChange="afterCountry"
                    ></select-country>
                  </v-col>
                </v-row>
                <v-row v-show="Member.RegisterType == 'SMS'">
                  <v-col cols="3">
                    <v-text-field
                      :label="$t('label.mobile_prefix')"
                      v-model="Member.MobilePrefix"
                      prefix="+"
                      type="text"
                      inputmode="decimal"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      :label="$t('label.mobile_no')"
                      v-model="Member.MobileNo"
                      type="text"
                      inputmode="decimal"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <v-card-actions class="justify-center">
                <v-btn
                  color="primary"
                  @click="sendShortCode"
                  width="150px"
                  v-show="!isSendingShortCode"
                >
                  {{ $t("label.continue") }}<v-icon>{{ mdiArrowRight }}</v-icon>
                </v-btn>
                <v-progress-circular
                  :width="2"
                  color="primary"
                  indeterminate
                  v-show="isSendingShortCode"
                ></v-progress-circular>
              </v-card-actions>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card class="mb-12">
                <v-row>
                  <v-col class="mx-auto">
                    {{
                      $t("message.input_short_code", {
                        type:
                          Member.RegisterType == "EMAIL"
                            ? $t("label.email")
                            : $t("label.sms"),
                      })
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="mx-auto">
                    <v-text-field
                      :label="$t('label.short_code')"
                      type="text"
                      inputmode="decimal"
                      v-model="Member.ShortCode"
                      prefix="FG-"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions class="justify-center">
                <v-btn
                  color="primary"
                  @click="forget_form = 1"
                  width="150px"
                  v-show="!isVerifyingShortCode"
                >
                  <v-icon>{{ mdiArrowLeft }}</v-icon
                  >{{ $t("label.back") }}
                </v-btn>

                <v-btn
                  color="primary"
                  @click="verifyShortCode"
                  width="150px"
                  v-show="!isVerifyingShortCode"
                >
                  {{ $t("label.continue") }}<v-icon>{{ mdiArrowRight }}</v-icon>
                </v-btn>
                <v-progress-circular
                  :width="2"
                  color="primary"
                  indeterminate
                  v-show="isVerifyingShortCode"
                ></v-progress-circular>
              </v-card-actions>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-12">
                <v-row no-gutters>
                  <v-col>
                    {{ $t("message.password_requirement") }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <v-text-field
                      :label="$t('label.password')"
                      :rules="passwordRules"
                      required
                      v-model="Member.Password"
                      :type="show1 ? 'text' : 'password'"
                      :append-icon="show1 ? mdiEye : mdiEyeOff"
                      @click:append="show1 = !show1"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <v-text-field
                      :label="$t('label.confirm_password')"
                      :rules="passwordRules"
                      required
                      v-model="Member.PasswordC"
                      :type="show2 ? 'text' : 'password'"
                      :append-icon="show2 ? mdiEye : mdiEyeOff"
                      @click:append="show2 = !show2"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions class="justify-center">
                <v-btn
                  color="primary"
                  @click="forget_form = 2"
                  width="150px"
                  v-show="!isRegistering"
                >
                  <v-icon>{{ mdiArrowLeft }}</v-icon
                  >{{ $t("label.back") }}
                </v-btn>
                <v-btn
                  color="primary"
                  @click="confirm()"
                  width="150px"
                  v-show="!isRegistering"
                >
                  {{ $t("label.confirm") }}<v-icon>{{ mdiPlay }}</v-icon>
                </v-btn>
                <v-progress-circular
                  :width="2"
                  color="primary"
                  indeterminate
                  v-show="isRegistering"
                ></v-progress-circular>
              </v-card-actions>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-card class="mb-12">
                <v-row>
                  <v-col>
                    <p class="text-subtitle-1 font-weight-bold text-center">
                      {{ $t("message.password_reset") }}
                    </p>
                  </v-col>
                </v-row>
                <v-card-actions class="justify-center">
                  <v-btn
                    color="primary"
                    @click="openLoginDialog()"
                    width="150px"
                    class="mx-5"
                    >{{ $t("label.login") }}</v-btn
                  >

                  <v-btn color="primary" @click="toHome()" width="150px">
                    {{ $t("label.return_home") }}<v-icon>{{ mdiPlay }}</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>

      <snackbar-msg
        v-model="snackBarMsg.show"
        :text="snackBarMsg.text"
        :color="snackBarMsg.color"
      ></snackbar-msg>
    </div>
    <!-- <Footer></Footer> -->
  </v-container>
</template>

<script>
import {
  mdiArrowRight,
  mdiArrowLeft,
  mdiEye,
  mdiEyeOff,
  mdiPlay,
  mdiClose,
} from "@mdi/js";
import {
  ForgotBySms,
  ForgotByEmail,
  ResetPassword,
  ValidateShortCode,
} from "@/api/publicServices";
import i18n from "../lang/lang";

export default {
  metaInfo: {
    title: "忘記密碼",
    titleTemplate: "%s | 青蛙集運",
  },
  props: ["nextUrl"],
  components: {
  },
  mounted() {
    if (this.$route.query.SalesCode != undefined) {
      this.Member.SalesCode = this.$route.query.SalesCode;
    }
  },
  data() {
    return {
      rules: [
        (value) => !!value || "Required.",
        (value) => (value && value.length >= 3) || "Min 3 characters",
      ],
      title_rules: [
        (value) => !!value || "Required.",
        (value) => (value && value.length >= 2) || "Min 3 characters",
      ],

      emailRules: [
        (value) => !!value || i18n.t("label.required"),
        (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return (
            pattern.test(value) ||
            i18n.t("message.invalid_field", { type: i18n.t("label.email") })
          );
        },
      ],

      passwordRules: [
        (value) => !!value || i18n.t("label.required"),
        (value) => {
          //const pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/
          const pattern = /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,30}$/;
          return (
            pattern.test(value) ||
            i18n.t("message.invalid_field", { type: i18n.t("label.password") })
          );
        },
      ],
      Member: {
        MobilePrefix: "852",
        MobileNo: "",
        Email: "",
        RegisterType: "SMS",
        Country: "",
        VerificationID: "",
        ShortCode: "",
        Password: "",
        PasswordC: "",
      },

      snackBarMsg: {
        show: false,
        text: "",
        color: "red",
      },

      dialog: false,
      forget_form: 1,
      Country: {
        CntyCode: "HK",
        CntyName: "HONG KONG",
        CnName: "香港",
        TelPrefix: "852",
      },
      isSendingShortCode: false,
      isVerifyingShortCode: false,
      isRegistering: false,
      show1: false,
      show2: false,
      menuOptions: [
        "self-pick-spot",
        "pricing",
        "news",
        "faq",
        "login",
        "locale",
      ],

      // svg icons
      mdiArrowRight,
      mdiArrowLeft,
      mdiEye,
      mdiEyeOff,
      mdiPlay,
      mdiClose,
    };
  },
  methods: {
    getCountryCode() {
      if (this.country == null) {
        return "";
      }
      return this.country.CountryCode;
    },
    async sendShortCode(e) {
      e.preventDefault();
      this.isSendingShortCode = true;
      try {
        const response = await this.verify();
        this.snackBarMsg.text = "";
        //this.snackBarMsg.show = false;
        if (response.data.isSuccess) {
          this.Member.VerificationID = response.data.Key;
          this.forget_form = 2;
        } else {
          this.snackBarMsg.text = response.data.Msg;
          this.snackBarMsg.show = true;
        }
        this.isSendingShortCode = false;
      } catch (error) {
        console.log(error);
        this.snackBarMsg.text = "Service Error";
        this.snackBarMsg.show = true;
        this.isSendingShortCode = false;
      }
    },
    async verify() {
      if (this.Member.RegisterType == "EMAIL") {
        let data = {};
        data.Email = this.Member.Email;

        return await ForgotByEmail(data);
      } else {
        let data = {};
        data.MobilePrefix = this.Member.MobilePrefix;
        data.MobileNo = this.Member.MobileNo;

        return await ForgotBySms(data);
      }
    },
    async verifyShortCode() {
      this.isVerifyingShortCode = true;
      try {
        let data = {};
        data.VerificationID = this.Member.VerificationID;
        data.ShortCode = this.Member.ShortCode;
        const response = await ValidateShortCode(data);
        this.snackBarMsg.text = "";
        if (response.data.isSuccess) {
          this.forget_form = 3;
        } else {
          this.snackBarMsg.text = response.data.Msg;
          this.snackBarMsg.show = true;
        }
        this.isVerifyingShortCode = false;
      } catch (error) {
        console.log(error);
        this.isVerifyingShortCode = false;
      }
    },
    async confirm() {
      this.isRegistering = true;
      this.Member.Country = this.Country.CntyCode;
      var isValid = await this.isValid();
      if (!isValid) {
        this.isRegistering = false;
        return;
      }

      let data = {};
      data["Password"] = this.Member.Password;
      data["VerificationID"] = this.Member.VerificationID;
      try {
        const response = await ResetPassword(data);

        this.snackBarMsg.text = "";
        console.log(response);
        if (response.data.isSuccess) {
          // this.snackBarMsg.text = i18n.t("message.password_reset_success");
          // this.snackBarMsg.show = true;
          this.forget_form = 4;
        } else {
          this.snackBarMsg.text = response.data.Msg;
          this.snackBarMsg.show = true;
        }

        this.isRegistering = false;
      } catch (error) {
        console.log(error);
        this.isRegistering = false;
      }
    },
    isValid() {
      var isValid = true;
      this.snackBarMsg.text = "";

      let messages = [];
      if (this.Member.Country == "") {
        messages.push(
          i18n.t("message.is_empty", {
            type: i18n.t("label.country"),
          })
        );
        isValid = false;
      }

      if (this.Member.RegisterType == "SMS") {
        if (this.Member.MobilePrefix == "") {
          messages.push(
            i18n.t("message.is_empty", {
              type: i18n.t("label.mobile_prefix"),
            })
          );
          isValid = false;
        }

        if (this.Member.MobileNo == "") {
          messages.push(
            i18n.t("message.is_empty", {
              type: i18n.t("label.mobile_no"),
            })
          );
          isValid = false;
        }
      } else {
        if (this.Member.Email == "") {
          messages.push(
            i18n.t("message.is_empty", {
              type: i18n.t("label.email"),
            })
          );
          isValid = false;
        }
      }

      if (this.Member.VerificationID == "") {
        messages.push(
          i18n.t("message.is_empty", {
            type: i18n.t("label.verification_id"),
          })
        );
        isValid = false;
      }

      if (this.Member.ShortCode == "") {
        messages.push(
          i18n.t("message.is_empty", {
            type: i18n.t("label.short_code"),
          })
        );
        isValid = false;
      }

      if (this.Member.Password == "") {
        messages.push(
          i18n.t("message.is_empty", {
            type: i18n.t("label.password"),
          })
        );
        isValid = false;
      }

      if (this.Member.Password != this.Member.PasswordC) {
        messages.push(
          i18n.t("message.not_match", {
            type: i18n.t("label.password"),
          })
        );
        isValid = false;
      }

      if (!isValid) {
        this.snackBarMsg.text = messages.join("\r\n");
        this.snackBarMsg.show = true;
      }
      return isValid;
    },
    afterCountry() {
      this.Member.MobilePrefix = "";
      if (this.Country != null) {
        this.Member.MobilePrefix = this.Country.TelPrefix;
      }
    },
    toHome() {
      this.$router.replace({ name: "home" });
    },
    openLoginDialog() {
      this.$refs.mainmenu.openLoginDialog();
    },
    toPage(page) {
      let routeData = this.$router.resolve({ name: page });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped></style>
